export function isPageType(data: any, pageType: string) {
  const component = data?.component?.toLowerCase();
  return component === pageType.toLowerCase();
}
